import { useTranslation } from 'react-i18next'

import { Tab } from '../Tab'

import * as styles from './TabList.module.css'

function TabList({
  activeTab,
  className = styles.TabList,
  getTabs,
  tabProps,
  onSetActiveTab,
}) {
  const { t } = useTranslation()

  function getHandleSetActive(name) {
    return () => onSetActiveTab(name)
  }

  const tabs = getTabs(t)

  return (
    <div className={className}>
      {tabs.map(tab => (
        <Tab
          {...tabProps}
          {...tab}
          isActive={activeTab === tab.id}
          key={tab.id}
          onClick={getHandleSetActive(tab.id)}
        />
      ))}
    </div>
  )
}

export default TabList
